import { ref, watch, computed } from '@vue/composition-api';
import store from '@/store';
import { formatDateBr } from '@core/utils/filter';
import SLSClienteService from '@/services/Cadastros/Cliente/SLSCliente.service';
// Notification
import { useToast } from 'vue-toastification/composition';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';

export default function useUsersList(nameModule) {
  // Use toast
  const toast = useToast();
  const sLSClienteService = new SLSClienteService();
  const refClienteListTable = ref(null);

  // Table Handlers
  const tableColumns = [
    { key: 'clienteid', label: 'Codigo KS', sortable: false },
    { key: 'clienteiderp', label: 'Codigo ERP', sortable: true },
    { key: 'clienterazaosocial', label: 'Razão Social', sortable: true },
    { key: 'clientetipopessoa', label: 'Tipo Pessoa', sortable: true },
    { key: 'clientecnpj', label: 'CNPJ', sortable: true },
    { key: 'clientestatus', label: 'Situação', sortable: true },
    { key: 'clientesitintegracao', label: 'Sit. Integração', sortable: true },
    { key: 'actions', label: 'Ações', sortable: false },
  ];
  const perPage = ref(10);
  const totalCliente = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref('');
  const sortBy = ref('clienteid');
  const isSortDirDesc = ref(false);
  const overlay = ref(true);
  const statusFilter = ref(null);
  const filterSituacao = ref('');
  const filterIntegracao = ref('');
  const filterTipoPessoa = ref('');
  const filterCnpj = ref('');

  const dataMeta = computed(() => {
    const localItemsCount = refClienteListTable.value ? refClienteListTable.value.localItems.length : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalCliente.value,
    };
  });

  const refetchData = () => {
    refClienteListTable.value.refresh();
  };

  watch([currentPage, perPage, searchQuery, statusFilter, filterSituacao, filterIntegracao, filterTipoPessoa, filterCnpj], () => {
    refetchData();
  });

  const fetchCliente = (ctx, callback) => {
    overlay.value = true;
    sLSClienteService.index({
      q: searchQuery.value,
      perPage: perPage.value,
      page: currentPage.value,
      sortBy: sortBy.value,
      sortDesc: isSortDirDesc.value,
      fullObject: true,
      ...(filterSituacao.value ? { clientestatus: filterSituacao.value } : {}),
      ...(filterIntegracao.value ? { clientesitintegracao: filterIntegracao.value } : {}),
      ...(filterTipoPessoa.value ? { clientetipopessoa: filterTipoPessoa.value } : {}),
      ...(filterCnpj.value ? { clientecnpj: filterCnpj.value } : {}),
    }).then((response) => {
      const { data, total } = response;
      overlay.value = false;
      callback(data);
      perPage.value = response.perPage;
      currentPage.value = response.page;
      totalCliente.value = total;
    })
      .catch((error) => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error fetching users list',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        });
      });
  };

  const create = async (body) => {
    await sLSClienteService.store(body);
    refetchData();
  };
  const Updated = async (body) => {
    await sLSClienteService.update(body);
    refetchData();
  };

  const removerData = async (id) => {
    await sLSClienteService.destroy(id);
    refetchData();
  };

  const resolveTypeFieldText = type => {
    if (type === 'VARCHAR') return 'Texto';
    if (type === 'BOOLEAN') return 'Verdadeiro/Falso';
    if (type === 'DATE') return 'Data';
    if (type === 'DATETIME') return 'Data e Hora';
    if (type === 'DECIMAL') return 'Monetário';
    if (type === 'TEXT') return 'Texto Longo';
    if (type === 'INTEGER' || type === 'INT') return 'Númerico';
    return 'Sem Tipo';
  };
  const resolveTypeFieldIcon = type => {
    if (type === 'VARCHAR') return 'tabler:abc';
    if (type === 'BOOLEAN') return 'Verdadeiro/Falso';
    if (type === 'DATE') return 'system-uicons:calendar-date';
    if (type === 'DATETIME') return 'formkit:datetime';
    if (type === 'TEXT') return 'mdi:text-long';
    if (type === 'DECIMAL') return 'tabler:decimal';
    if (type === 'DECIMAL' || type === 'INTEGER' || type === 'INT') return 'tabler:123';
    return 'nonicons:type-16';
  };

  const resolveItemStatusVariant = (status) => {
    if (status === 'PENDING') return 'light-warning';
    if (status === 'ATIVO') return 'light-success';
    if (status === 'INATIVO') return 'light-danger';
    return 'primary';
  };

  return {
    fetchCliente,
    tableColumns,
    perPage,
    currentPage,
    totalCliente,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refClienteListTable,
    overlay,
    resolveTypeFieldText,
    resolveTypeFieldIcon,
    resolveItemStatusVariant,
    refetchData,
    create,
    Updated,

    // Extra Filters
    statusFilter,
    filterSituacao,
    filterIntegracao,
    filterTipoPessoa,
    filterCnpj,
    removerData,
  };
}
